"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var default_1 = (function () {
    function default_1(_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.selectorSets, selectorSets = _c === void 0 ? ".flextabs" : _c, _d = _b.selectorTabs, selectorTabs = _d === void 0 ? ".flextabs__tab" : _d, _e = _b.selectorButtons, selectorButtons = _e === void 0 ? ".flextabs__button" : _e;
        var sets = document.querySelectorAll(selectorSets);
        if (!sets)
            return;
        sets.forEach(function (set) {
            var tabs = set.querySelectorAll(selectorTabs);
            var buttons = set.querySelectorAll(selectorButtons);
            if (tabs.length && buttons.length) {
                buttons.forEach(function (button) {
                    return button.addEventListener("click", function (e) {
                        e.preventDefault();
                        tabs.forEach(function (tab) {
                            tab.removeAttribute("aria-expanded");
                        });
                        var tab = e.target.closest(selectorTabs);
                        if (tab) {
                            tab.setAttribute("aria-expanded", "true");
                        }
                    });
                });
                tabs[0].setAttribute("aria-expanded", "true");
            }
        });
    }
    return default_1;
}());
exports.default = default_1;
